import { render } from "./SchedulerDocumentsTable.vue?vue&type=template&id=200b72c6&ts=true"
import script from "./SchedulerDocumentsTable.vue?vue&type=script&lang=ts"
export * from "./SchedulerDocumentsTable.vue?vue&type=script&lang=ts"

import "./SchedulerDocumentsTable.vue?vue&type=style&index=0&id=200b72c6&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__